import FlatTable, { flatValue } from "../../../../../../Components/common/FlatTable/FlatTable";

import "./flatStyles.scss";

const MAX_PERMISSIONS = 60;

// Manifest and Details are what the interactive widget hides behind its expand
// row; folding them into the table keeps everything in one pass.
const columns = [
  {
    label: "Name",
    render: (row) => flatValue(row?.simplified_name),
    className: "android-permissions-flat__name",
  },
  { label: "Severity", render: (row) => flatValue(row?.severity) },
  {
    label: "Tags",
    render: (row) => (Array.isArray(row?.tags) && row.tags.length > 0 ? row.tags.join(", ") : "-"),
  },
  { label: "Description", render: (row) => flatValue(row?.description) },
  { label: "Manifest", render: (row) => flatValue(row?.permission) },
  { label: "Details", render: (row) => flatValue(row?.details) },
];

// Stateless counterpart of Permissions.js.
const PermissionsFlat = ({ data }) => (
  <div className="android-permissions-flat">
    <FlatTable
      columns={columns}
      data={data}
      maxRows={MAX_PERMISSIONS}
      moreLabel="permissions"
      emptyMessage="No permissions found"
    />
  </div>
);

export default PermissionsFlat;
